/** Draft CIS returns for the "Coming up" list, read through the CIS list's own
 *  cache-filling fetch. The caller passes a workspace only for roles that may
 *  open CIS Returns. Any failure just means no rows. Refetches when the date
 *  changes so a deadline entering the window appears on a dashboard left open
 *  overnight. */

import { useEffect, useMemo, useState } from 'react';
import type { CISReturn } from '../../types/accounting';
import { useBackgroundRead } from '../../hooks/useBackgroundRead';
import { draftCisReturnsRead, londonDayKey } from './homeComingUpReads';

const DAY_CHECK_MS = 5 * 60_000;
const NONE: readonly CISReturn[] = [];

export function useDraftCisReturns(workspaceId: string | undefined): readonly CISReturn[] {
  const [dayKey, setDayKey] = useState(londonDayKey);

  useEffect(() => {
    const id = window.setInterval(() => setDayKey(londonDayKey()), DAY_CHECK_MS);
    return () => window.clearInterval(id);
  }, []);

  const read = useMemo(() => (workspaceId ? draftCisReturnsRead(workspaceId) : null), [workspaceId]);
  return useBackgroundRead(workspaceId, read, { refreshKey: dayKey }) ?? NONE;
}
